import { Clamp } from "./types";

export const clamp: Clamp = ({ value, min, max }) => {
  return Math.min(max, Math.max(min, value));
};
